import Vue from 'vue'
import Router from 'vue-router'
import ShortKey from 'vue-shortkey'
import VueCookie from 'vue-cookie'
import VueSignaturePad from 'vue-signature-pad'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import exportingInit from 'highcharts/modules/exporting'
import offlineExporting from 'highcharts/modules/offline-exporting'
exportingInit(Highcharts)
offlineExporting(Highcharts)
Highcharts.setOptions({
  colors: Highcharts.map(Highcharts.getOptions().colors, function (color) {
      return {
          radialGradient: {
              cx: 0.5,
              cy: 0.3,
              r: 0.7
          },
          stops: [
              [0, color],
              [1, Highcharts.Color(color).brighten(-0.3).get('rgb')] // darken
          ]
      }
  })
})

Vue.use(Router)
Vue.use(ShortKey)
Vue.use(VueCookie)
Vue.use(VueSignaturePad)
Vue.use(HighchartsVue, { Highcharts })

export default new Router({
  //mode: 'history',
  //base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/dashboard',
      component: () => import('../pages/Home'),
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          title: 'Dashboard',
          component: () => import('../pages/Dashboard')
        },
        {
          path: 'canvas',
          name: 'Canvas',
          title: 'Canvas',
          component: () => import('../pages/Canvas')
        },
        {
          path: 'promotion',
          name: 'Promotion',
          title: 'Promotion',
          component: () => import('../pages/Promotion')
        }
      ]
    }
  ]
})
